import {AfterViewInit, Component, DoCheck, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {SelectListResponse, TenantsClient} from '../generated-client/generated-api-client';
import {ErrorProcessorService} from '../services/error-processor.service';
import {TenantService} from '../services/tenant.service';
import {Router} from '@angular/router';
import {AuthHelperService} from "../services/auth-helper.service";
import {RoleConstants} from "../constants/roleConstants";

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.sass'],
})
export class TopBarComponent implements OnInit, DoCheck, AfterViewInit {
  private _selectedTenantId?: string;

  title: string;
  userName: string;
  tenantSelectList!: SelectListResponse;
  isLoading: boolean = true;
  hasRole = this._authHelper.hasRole([RoleConstants.Admin, RoleConstants.Clerk, RoleConstants.TenantAdmin]);

  constructor(
    private _titleService: Title,
    private _oidcSecurityService: OidcSecurityService,
    private _tenantService: TenantService,
    private _tenantsClient: TenantsClient,
    private _errorProcessorService: ErrorProcessorService,
    private _router: Router,
    private _authHelper: AuthHelperService,
  ) {
    this.title = '';
    this.userName = _authHelper.getDisplayName();
  }

  ngOnInit(): void {}

  ngDoCheck(): void {
    this.title = this._titleService.getTitle();
  }

  ngAfterViewInit() {
    if (!this.hasRole) {
      return;
    }

    this._tenantService.tenantSelectList.subscribe(list => {
      if (!list) {
        return;
      }

      this.tenantSelectList = list;

      const activeTenantId = this._tenantService.activeTenantId;
      if (activeTenantId && list.items?.some(x => x.value === activeTenantId)) {
        this.selectedTenantId = activeTenantId;
      } else {
        this._tenantService.clearActiveTenantId();
        const firstValue = list.items?.find(x => x.value);
        if (firstValue) {
          this.selectedTenantId = firstValue.value as string;
        }
      }
      this.isLoading = false;
    });

    this._tenantService.refreshTenantSelectList(this._tenantsClient);
  }

  logout(): void {
    this._oidcSecurityService.logoffAndRevokeTokens().subscribe(() => {});
  }

  get selectedTenantId() {
    return this._selectedTenantId ?? '';
  }

  set selectedTenantId(value: string) {
    if (value !== this._selectedTenantId) {
      this._selectedTenantId = value;
      this._tenantService.setActiveTenantId(value);
    }
  }
}
